import Table from '@risksmart-app/components/src/table';
import type { FC } from 'react';
import { useNavigate } from 'react-router';
import type { useGetAppetitesGroupedByImpact } from 'src/hooks/queries/appetite/useGetAppetitesGroupedByImpact';
import type { useGetImpactRatings } from 'src/hooks/queries/impact-rating/useGetImpactRatings';
import { useGetCollectionStatelessTableProps } from 'src/pages/impacts/ratings/config';

import type { CollectionData } from '@/utils/collectionUtils';
import { assessmentResultsEditUrl } from '@/utils/urls';

type GetImpactRatingsData = NonNullable<
  ReturnType<typeof useGetImpactRatings>['data']
>;

type GetAppetitesGroupedByImpactData = NonNullable<
  ReturnType<typeof useGetAppetitesGroupedByImpact>['data']
>;

type ImpactRating = CollectionData<
  GetImpactRatingsData['impact_rating'][number]
>;
type ImpactAppetites = CollectionData<
  GetAppetitesGroupedByImpactData['impact']
>;

interface Props {
  loading: boolean;
  assessmentId: string;
  records: ImpactRating[] | undefined;
  impactAppetites?: ImpactAppetites;
}

const ImpactOversightRatingRegister: FC<Props> = ({
  loading,
  assessmentId,
  records,
  impactAppetites,
}) => {
  const navigate = useNavigate();
  const tableProps = useGetCollectionStatelessTableProps(
    records,
    impactAppetites,
    (item) => navigate(assessmentResultsEditUrl(assessmentId, item.Id))
  );

  return <Table variant={'embedded'} {...tableProps} loading={loading} />;
};

export default ImpactOversightRatingRegister;
